/**
 * What a person is in a squad — the web's copy of src/groups/groupRoles.js in
 * the API. A normal squad only ever uses admin and member; a class squad (one a
 * program runs) uses the rest: its coach, its players and their parents.
 */
export const SQUAD_ROLES = ['admin', 'coach', 'member', 'player', 'parent', 'guardian'];

const LABELS = {
  admin: 'Admin',
  coach: 'Coach',
  member: 'Member',
  player: 'Player',
  parent: 'Parent',
  guardian: 'Guardian',
};

/** Who runs the squad: an admin or a coach — the same rule the API enforces. */
export const isSquadManager = (role) => role === 'admin' || role === 'coach';

/** A role as the screen says it; an unknown one is shown as it came, not hidden. */
export const roleLabel = (role) => LABELS[role] ?? role;
